import { defineComponent, useCssVars, computed, inject, createElementBlock, openBlock, mergeProps } from "vue";
import { createInjectionKey } from "../../../utils/index.js";
import { _export_sfc } from "../../WAccordion/index.js";
import './index.css';const iconSizeInjectionKey = createInjectionKey();
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WIconExt",
  props: {
    url: {},
    height: { default: void 0 },
    width: { default: void 0 },
    size: { default: 14 },
    color: { default: void 0 },
    currentColor: { type: Boolean, default: false }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "291fa870": iconWidth.value,
      "68c65365": iconHeight.value,
      "f6426f28": iconBackground.value,
      "5a2840aa": iconMask.value
    }));
    const props = __props;
    const injectionSize = inject(iconSizeInjectionKey, null);
    const size = computed(() => (injectionSize == null ? void 0 : injectionSize.value) ?? props.size);
    const iconColor = computed(
      () => {
        var _a;
        return ((_a = props.color) == null ? void 0 : _a.startsWith("--")) ? `var(${props.color})` : props.color;
      }
    );
    const iconBackground = computed(() => {
      return props.color === void 0 ? props.currentColor ? "currentColor" : `url(${props.url}) no-repeat center` : iconColor.value;
    });
    const iconMask = computed(
      () => props.color || props.currentColor ? `url(${props.url})` : "unset"
    );
    const iconWidth = computed(() => (props.width || size.value) + "px");
    const iconHeight = computed(() => (props.height || size.value) + "px");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("i", mergeProps({ class: "w-icon-ext" }, _ctx.$attrs), null, 16);
    };
  }
});
const WIconExt = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-a3ae7dd0"]]);
export {
  WIconExt,
  iconSizeInjectionKey
};
